export const COMPONENT_NAME = "shared-admin-header";
